export default "Lav jeres egne pensler af naturmaterialer, og mal ligesom i jægerstenalderen!";